module.exports = __webpack_public_path__ + "stylesheets/wave-tutorial-page_3e0f81681ac571e4abddb537b7992a34.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/tutorial/wave-tutorial-page.less
// module id = CDOh
// module chunks = 153